import React, { Component } from "react";
import moment from "moment";
import {
  FormGroup,
  FormLabel,
} from "react-bootstrap";
import async from "async";
import AlertModal from "../../components/AlertModal.tsx";
import CustomDatePicker from "../../components/CustomDatePicker";
import {
  getGroupUsers,
  getGroupRoles,
  getGroupInfo,
  updateGroupInfo,
  addRoleToGroup,
  removeRoleFromGroup,
  addUserToGroup,
  removeUserFromGroup,
} from "../../libs/db-lib";
import LoaderButton from "../../components/LoaderButton";
import { Loading } from "../../components/Loading.tsx";
import CustomTable from "../../components/CustomTable.tsx";
import ConfirmModal from "../../components/ConfirmModal.tsx";
import Tabs from "../../components/Tabs.tsx";
import Tab from "../../components/Tab.tsx";
import TextInput from "../../components/TextInput.tsx";

export default class EditGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      showUpdatedModal: false,
      showConfirmNavModal: false,
      groupName: props.group.groupName ?? "",
      showDeleteModal: false,
      user: props.user,
      group: props.group,
      roles: props.roles,
      rolesToDelete: [],
      rolesToAdd: [],
      users: props.users,
      usersToDelete: [],
      usersToAdd: [],
      newPage: "",
      isLoading: false,
      revertIsLoading: false,
      alertMessage: "",
      isLoadingPage: false,
    };
  }

  async componentDidMount() {
    if (!this.props.isAuthenticated) {
      return;
    }
    this.setState({ isLoadingPage: true });
    try {
      let group = {};
      if (this.props.group) {
        group = this.props.group;
      } else {
        group = await getGroupInfo(this.props.groupID);
        if (group?.error === 'Unauthorized') {
          alert("Logout")
        }
      }
      if (group?.validityParams && typeof group.validityParams?.startDate === "string") {
        group.validityParams.startDateStr = group.validityParams.startDate;
        group.validityParams.startDate = moment(new Date(group.validityParams.startDate));
        group.validityParams.endDateStr = group.validityParams.endDate;
        group.validityParams.endDate = moment(new Date(group.validityParams.endDate));
      }
      let groupRoles = await getGroupRoles(group.groupID);
      if (groupRoles?.error === 'Unauthorized') {
        alert("Logout");
      }
      groupRoles.forEach((role) => {
        role.rowID = "remove-" + role.roleID;
      });
      let origGroupRoles = [...groupRoles];

      let groupUsers = await getGroupUsers(group.groupID);
      groupUsers.forEach((user) => {
        user.rowID = "removeUser-" + user.userID;
      })
      let origGroupUsers = [...groupUsers];

      this.setState({
        group: group,
        groupName: group?.groupName ?? "",
        groupState: group?.groupState ?? "",
        validityCriteria: group?.validityCriteria ?? "",
        validityParams: group?.validityParams ?? {
            startDate: moment.utc().startOf("day"),
            endDate: moment.utc().endOf("day")
          },
        groupRoles: groupRoles ?? [],
        origGroupRoles: origGroupRoles ?? [],
        groupUsers: groupUsers ?? [],
        origGroupUsers: origGroupUsers ?? [],
      });
    } catch (e) {
      this.setState({
        alertMessage: e.message,
        showModal: true,
        isLoading: false,
        revertIsLoading: false,
        isLoadingPage: false,
      });
    }
    this.setState({
      isLoadingPage: false,
    })
  }

  validateForm() {
    let rolesToAdd = this.state.groupRoles
      ? this.state.groupRoles.filter((role) => {
          return (
            this.state.origGroupRoles.findIndex((orole) => role.roleID === orole.roleID) === -1
          );
        })
      : [];

    let rolesToRemove = this.state.origGroupRoles
      ? this.state.origGroupRoles.filter((role) => {
          return this.state.groupRoles.findIndex((orole) => role.roleID === orole.roleID) === -1;
        })
      : [];

    let usersToAdd = this.state.groupUsers
      ? this.state.groupUsers.filter((user) => {
          return (
            this.state.origGroupUsers.findIndex((ouser) => user.userID === ouser.userID) === -1
          );
        })
      : [];

    let usersToRemove = this.state.origGroupUsers
      ? this.state.origGroupUsers.filter((user) => {
          return this.state.groupUsers.findIndex((ouser) => user.userID === ouser.userID) === -1;
        })
      : [];

    let valid =
      this.state.groupName.length > 0 &&
      (this.state.groupName !== this.state.group.groupName ||
        this.state.validityCriteria !== this.state.group.validityCriteria ||
        (this.state.validityCriteria === "TIME" &&
          this.state.validityParams &&
          (!this.state.group.validityParams ||
            this.state.validityParams.startDate !== this.state.group.validityParams.startDate ||
            this.state.validityParams.endDate !== this.state.group.validityParams.endDate)) ||
        this.state.groupState !== this.state.group.groupState ||
        rolesToAdd.length > 0 ||
        rolesToRemove.length > 0 ||
        usersToAdd.length > 0 ||
        usersToRemove.length > 0);

    return valid;
  }

  handleCheckboxChange(tableType, row) {
    if (['rolesToDelete', 'rolesToAdd', 'usersToDelete', 'usersToAdd'].includes(tableType)) {
      const itemsToChange = [...this.state[tableType]];
      const idType = tableType.includes('users') ? 'userID' : 'roleID';
      if (!row.original.checked) {
        // If user checked the box
        row.original.checked = true;
        itemsToChange.push(row.original[idType]);
        this.setState({ [tableType]: itemsToChange });
      } else {
        // If user unchecked the box
        row.original.checked = false;
        let newItemsToChange = itemsToChange.filter((id) => {
          return !(id === row.original[idType]);
        });
        this.setState({ [tableType]: newItemsToChange });
      }
    }
  }

  handleChange = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  handleRangeChange = (value) => {
    const validityParams = {
      startDate: value.start,
      endDate: value.end,
    };
    this.setState({ validityParams: validityParams });
  };

  handleAddRole() {
    let groupRoles = [...this.state.groupRoles];
    this.state.rolesToAdd.forEach((role) => {
      let newRole = this.state.roles.find((grole) => grole.roleID === role);
      let newGRole = {};
      newGRole.roleID = newRole.roleID;
      newGRole.name = newRole.roleName;
      newGRole.description = newRole.roleDescription;
      groupRoles.push(newGRole);
      this.setState({
        groupRoles: groupRoles,
      });
    });
    const uncheckedRoles = [...this.state.roles];
    uncheckedRoles.forEach((role) => {
      role.checked = false;
    });
    this.setState({
      rolesToAdd: [],
      roles: uncheckedRoles,
    });
  }

  handleRemoveRole() {
    let groupRoles = [...this.state.groupRoles];
    this.state.rolesToDelete.forEach((role) => {
      groupRoles = groupRoles.filter((grole) => grole.roleID !== role);
      this.setState({
        groupRoles: groupRoles,
      });
    });
    this.setState({ rolesToDelete: [] });
  }

  handleAddUser() {
    let groupUsers = [...this.state.groupUsers];
    this.state.usersToAdd.forEach((user) => {
      let newUser = this.state.users.find((guser) => guser.userID === user);
      groupUsers.push({ ...newUser, checked: false });
      this.setState({
        groupUsers: groupUsers,
      });
    });
    const uncheckedUsers = [...this.state.users];
    uncheckedUsers.forEach((user) => {
      user.checked = false;
    });
    this.setState({
      usersToAdd: [],
      users: uncheckedUsers,
    });
  }

  handleRemoveUser() {
    let groupUsers = [...this.state.groupUsers];
    this.state.usersToDelete.forEach((user) => {
      groupUsers = groupUsers.filter((guser) => guser.userID !== user);
      this.setState({
        groupUsers: groupUsers,
      });
    });
    this.setState({ usersToDelete: [] });
  }

  handleCancel = () => {
    this.setState({ showModal: false });
  };

  handleNavCancel = () => {
    this.setState({
      showConfirmNavModal: false,
      newPage: "",
    });
  };

  handleNavConfirm = (newPage) => {
    this.props.history.push({ pathname: newPage });
  };

  handleHideUpdatedModal = () => {
    this.setState({ showUpdatedModal: false });
  };

  handleBreadcrumbClick = (newPage, event) => {
    if (this.validateForm()) {
      this.setState({
        showConfirmNavModal: true,
        newPage: newPage,
      });
    } else {
      this.props.history.push({ pathname: newPage });
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    this.setState({ isLoading: true });
    let self = this;

    try {
      let group = self.state.group;
      self.setState({ group: group });

      let rolesToAdd = self.state.groupRoles.filter((role) => {
        return self.state.origGroupRoles.findIndex((orole) => role.roleID === orole.roleID) === -1;
      });
      await async.each(
        rolesToAdd,
        async (role) => {
          await addRoleToGroup(self.state.group.groupID, role.roleID);
        },
        (e) => {
          if (e) {
            self.setState({
              alertMessage: "Error adding roles to group: " + e.message,
              showModal: true,
              isLoading: false,
            });
            throw e;
          }
        }
      );
      rolesToAdd.forEach((role) => {
        role.addedByName = self.state.user.firstName + " " + self.state.user.lastName;
        role.addedOn = new Date();
        self.state.origGroupRoles.push(role);
        self.state.groupRoles.map((grole) => {
          if (grole.roleID === role.roleID) {
            return role;
          } else {
            return grole;
          }
        });
      });

      let rolesToRemove = self.state.origGroupRoles.filter((role) => {
        return self.state.groupRoles.findIndex((orole) => role.roleID === orole.roleID) === -1;
      });
      await async.each(
        rolesToRemove,
        async (role) => {
          await removeRoleFromGroup(self.state.group.groupID, role.roleID);
        },
        (e) => {
          if (e) {
            self.setState({
              alertMessage: "Error removing roles from group: " + e.message,
              showModal: true,
              isLoading: false,
            });
            throw e;
          }
        }
      );
      self.state.origGroupRoles = self.state.origGroupRoles.filter((role) => {
        return self.state.groupRoles.findIndex((orole) => role.roleID === orole.roleID) !== -1;
      });

      let usersToAdd = self.state.groupUsers.filter((user) => {
        return self.state.origGroupUsers.findIndex((ouser) => user.userID === ouser.userID) === -1;
      });
      async.each(
        usersToAdd,
        async (user) => {
          // await addUserToGroup(self.state.user.userType, self.state.group.groupID, user.userID);
          await addUserToGroup(self.state.group.groupID, user.userID);
        },
        (e) => {
          if (e) {
            self.setState({
              alertMessage: "Error adding users to group: " + e.message,
              showModal: true,
              isLoading: false,
            });
            throw e;
          }
        }
      );
      usersToAdd.forEach((user) => {
        user.addedByName = self.state.user.firstName + " " + self.state.user.lastName;
        user.addedOn = new Date();
        self.state.origGroupUsers.push(user);
        self.state.groupUsers.map((guser) => {
          if (guser.userID === user.userID) {
            return user;
          } else {
            return guser;
          }
        });
      });

      let usersToRemove = self.state.origGroupUsers.filter((user) => {
        return self.state.groupUsers.findIndex((ouser) => user.userID === ouser.userID) === -1;
      });
      async.each(
        usersToRemove,
        async (user) => {
          // await removeUserFromGroup(
          //   self.state.user.userType,
          //   self.state.group.groupID,
          //   user.userID
          // );
          await removeUserFromGroup(
            self.state.group.groupID,
            user.userID
          );
        },
        (e) => {
          if (e) {
            self.setState({
              alertMessage: "Error removing roles from group: " + e.message,
              showModal: true,
              isLoading: false,
            });
            throw e;
          }
        }
      );
      self.state.origGroupUsers = self.state.origGroupUsers.filter((user) => {
        return self.state.groupUsers.findIndex((ouser) => user.userID === ouser.userID) !== -1;
      });

      if (
        (self.state.groupName?.length > 0 && self.state.groupName !== self.state.group.groupName) ||
        self.state.groupState !== self.state.group.groupState ||
        self.state.validityCriteria !== self.state.group.validityCriteria ||
        (self.state.validityCriteria === "TIME" &&
          self.state.validityParams &&
          (!self.state.group.validityParams ||
            self.state.validityParams.startDate !== self.state.group.validityParams.startDate ||
            self.state.validityParams.endDate !== self.state.group.validityParams.endDate))
      ) {
        let result;
        if (
          self.state.validityCriteria !== self.state.group.validityCriteria ||
          (self.state.validityCriteria === "TIME" &&
            self.state.validityParams &&
            (!self.state.group.validityParams ||
              self.state.validityParams.startDate !== self.state.group.validityParams.startDate ||
              self.state.validityParams.endDate !== self.state.group.validityParams.endDate))
        ) {
          result = await updateGroupInfo(
            self.state.group.groupID,
            self.state.groupName,
            self.state.groupState,
            self.state.validityCriteria,
            self.state.validityParams
          );
        } else {
          result = await updateGroupInfo(
            self.state.group.groupID,
            self.state.groupName,
            self.state.groupState
          );
        }
        if (result?.error) {
          throw new Error(result.error);
        }
      }
    } catch (e) {
      self.setState({
        alertMessage: e.message,
        showModal: true,
        isLoading: false,
      });
      throw e;
    }
    self.state.group.groupName = self.state.groupName;
    self.state.group.groupState = self.state.groupState;
    self.state.group.validityCriteria = self.state.validityCriteria;
    self.state.group.validityParams = self.state.validityParams;

    self.setState({
      showUpdatedModal: true,
      isLoading: false,
    });
  };

  handleRevert = async (event) => {
    this.setState({ revertIsLoading: true });

    this.setState({
      groupRoles: this.state.origGroupRoles,
      groupUsers: this.state.origGroupUsers,
      groupName: this.state.group.groupName,
      groupState: this.state.group.groupState,
      validityCriteria: this.state.group.validityCriteria,
      validityParams: this.state.group.validityParams,
      revertIsLoading: false,
    });
  };

  render() {
    const startingTab = this.props.tab;

    const columnDefs = [];
    columnDefs.push({ header: "Name", accessorKey: "name", size: 150, enableGrow: true });
    columnDefs.push({
      header: "Description",
      id: "description",
      accessorKey: "description",
      size: 150,
      enableGrow: true,
    });
    columnDefs.push({
      header: "Added By",
      id: "addedByName",
      accessorKey: "addedByName",
      size: 100,
      enableGrow: true,
    });
    columnDefs.push({
      header: "Added On",
      id: "addedOn",
      cell: ({row}) => {
        return <div>{row.original.addedOn ? moment(row.original.addedOn).format("ll") : ""}</div>;
      },
      size: 100,
    });

    let groupRoles = this.state?.groupRoles?.length > 0
      ? this.state.groupRoles
      : [];

    const roleColDefs = [];
    roleColDefs.push({ header: "Name", id: 'roleName', accessorKey: "roleName", size: 100, enableGrow: true });
    roleColDefs.push({
      header: "Description",
      id: "roleDescription",
      accessorKey: "roleDescription",
      size: 150,
      enableGrow: true,
    });

    let roles = this.state.roles?.length > 0 ? this.state.roles : [];
    let filteredRoles = roles.filter(
      (role) => groupRoles.findIndex((grole) => grole.roleID === role.roleID) === -1
    ).map((role) => {
      role.rowID = "add-" + role.roleID;
      return role;
    });

    // Users tables
    const groupUsersColDefs = [];
    groupUsersColDefs.push({
      header: "Name",
      id: "userID",
      cell: ({row}) => {
        return <div>{row.original.firstName + " " + row.original.lastName}</div>;
      },
      sortMethod: (a, b) => {
        let userA = this.state.users ? this.state.users.find((user) => user.userID === a) : {};
        let userB = this.state.users ? this.state.users.find((user) => user.userID === b) : {};
        let userNameA = userA.firstName + " " + userA.lastName;
        let userNameB = userB.firstName + " " + userB.lastName;
        return userNameA > userNameB ? 1 : -1;
      },
      filterMethod: (filter, row) => {
        let filterRegex = new RegExp(filter.value, "i");
        return (
          filterRegex.test(row._original.firstName) || filterRegex.test(row._original.lastName)
        );
      },
      size: 150,
      enableGrow: true,
    });
    groupUsersColDefs.push({
      Header: "Username",
      id: "userName",
      accessor: "userName",
      size: 100,
      enableGrow: true,
    });
    groupUsersColDefs.push({
      Header: "Added On",
      id: "addedOn",
      Cell: ({row}) => {
        return <div>{moment(row.original.addedOn).format("ll")}</div>;
      },
      size: 100,
      enableGrow: true,
    });
    groupUsersColDefs.push({
      Header: "Type",
      id: "userType",
      accessor: "userType",
      size: 100,
      className: "flex-center",
      sortable: true,
      filterable: true,
    });

    let groupUsers =
      this.state?.groupUsers?.length > 0
        ? this.state.groupUsers
        : [];

    const userColDefs = [];
    userColDefs.push({
      header: "Name",
      id: "userID",
      Cell: ({row}) => {
        return <div>{row.original.firstName + " " + row.original.lastName}</div>;
      },
      sortMethod: (a, b) => {
        let userA = this.state.users ? this.state.users.find((user) => user.userID === a) : {};
        let userB = this.state.users ? this.state.users.find((user) => user.userID === b) : {};
        let userNameA = userA.firstName + " " + userA.lastName;
        let userNameB = userB.firstName + " " + userB.lastName;
        return userNameA > userNameB ? 1 : -1;
      },
      filterMethod: (filter, row) => {
        let filterRegex = new RegExp(filter.value, "i");
        return (
          filterRegex.test(row._original.firstName) || filterRegex.test(row._original.lastName)
        );
      },
      size: 150,
      enableGrow: true,
    });
    userColDefs.push({ header: "Username", id: "userName", accessorKey: "userName", size: 100, enableGrow: true, });
    userColDefs.push({ header: "Type", id: "userType", accessorKey: "userType", size: 100 });

    let users =
      this.state.users?.length > 0
        ? this.state.users.filter((u) => u.userState === "ACTIVE")
        : [];
    let filteredUsers = users.filter(
      (user) => groupUsers.findIndex((guser) => guser.userID === user.userID) === -1
    ).map((user) => {
      user.rowID = "addUser-" + user.userID;
      return user;
    });

    let startDate = this.state.validityParams?.startDate ?? moment.utc().startOf("day");
    let endDate = this.state.validityParams?.endDate ?? moment.utc().endOf("day");

    return (
      <div className="home">
        <div className="panel-frame">
          {!this.state.isLoadingPage ? (
            <div>
              <div className="l-container-sm-med">
                <form onSubmit={this.handleSubmit.bind(this)}>
                  <div className="l-flex-gap u-margin-bottom-20px">
                    <FormGroup className="col-sm-3">
                      <div className="col-sm-11">
                        <LoaderButton
                          block
                          className="red-button"
                          disabled={!this.validateForm() || this.state.revertIsLoading}
                          type="submit"
                          isLoading={this.state.isLoading}
                          text="Save Group"
                          loadingText="Updating group…"
                          onClick={this.handleSubmit.bind(this)}
                        />
                      </div>
                    </FormGroup>
                    <FormGroup className="col-sm-3">
                      <div className="col-sm-11">
                        <LoaderButton
                          block
                          className="red-button"
                          disabled={
                            (!this.validateForm() && this.state.groupName.length)
                            || this.state.isLoading
                          }
                          isLoading={this.state.revertIsLoading}
                          text="Revert to Saved"
                          loadingText="Reverting to saved…"
                          onClick={this.handleRevert.bind(this)}
                        />
                      </div>
                    </FormGroup>
                  </div>
                  <div className="row">
                    {this.state.user.userType === "OEM_ADMIN" ? (
                      <>
                        <FormLabel className="left-align">
                          Group Name:
                        </FormLabel>
                        <TextInput
                          controlID="groupName"
                          label="Group Name"
                          value={this.state.groupName}
                          onChange={this.handleChange}
                          errorCondition={!this.state.groupName.length}
                          errorMsg="Group Name cannot be blank"
                        />
                      </>
                    ) : (
                      <FormLabel className="col-sm-4">
                        Group Name: {this.state.groupName.length > 0 ? this.state.groupName : ""}
                      </FormLabel>
                    )}
                  </div>
                  <div className="row">
                    {this.state.user.userType === "OEM_ADMIN" ? (
                      <>
                        <FormLabel className="left-align">
                          State:
                        </FormLabel>
                        <div className="c-select left-align u-margin-bottom-15px">
                          <select
                            value={this.state.groupState}
                            className="col-sm-6"
                            onChange={this.handleChange.bind(this)}
                            id="groupState"
                          >
                            <option key="1" value="ACTIVE">
                              ACTIVE
                            </option>
                            <option key="2" value="INACTIVE">
                              INACTIVE
                            </option>
                          </select>
                        </div>
                      </>
                    ) : (
                      <FormLabel className="col-sm-4 u-margin-bottom-15px">
                        State: {this.state.groupState}
                      </FormLabel>
                    )}
                  </div>
                  <div className="row">
                    {this.state.user.userType === "OEM_ADMIN" ? (
                      <>
                        <FormLabel className="col-sm-2 left-align">
                          Validity Criteria:
                        </FormLabel>
                        <div className="c-select left-align u-margin-bottom-15px">
                          <select
                            value={this.state.validityCriteria}
                            className="col-sm-6"
                            onChange={this.handleChange.bind(this)}
                            id="validityCriteria"
                          >
                            <option key="1" value="NORMAL">
                              NORMAL
                            </option>
                            <option key="2" value="TIME">
                              TIME
                            </option>
                          </select>
                        </div>
                      </>
                    ) : (
                      <FormLabel className="col-sm-4 left-align margin-bottom-15">
                        Validity Criteria: {this.state.validityCriteria}
                      </FormLabel>
                    )}
                  </div>
                  {this.state.validityCriteria === "TIME" ? (
                    <div className="row margin-bottom-15">
                      <FormLabel className="col-sm-2 left-align">Start/End Time:</FormLabel>
                      {this.state.user.userType === "OEM_ADMIN" ? (
                        <div className="left-align">
                          <CustomDatePicker
                            value={{ start: startDate, end: endDate, name: "Custom" }}
                            onChange={this.handleRangeChange.bind(this)}
                          />
                        </div>
                      ) : (
                        <div className="col-sm-6 margin-bottom-15">
                          <FormLabel>
                            {this.state.validityParams
                              ? this.state.validityParams.startDateStr
                              : "<not set>"}
                          </FormLabel>
                          <FormLabel>
                            {this.state.validityParams
                              ? this.state.validityParams.endDateStr
                              : "<not set>"}
                          </FormLabel>
                        </div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </form>
              </div>

              <div className="l-container u-padding-none u-max-width-1122px">
                <Tabs
                  defaultActiveKey={startingTab === "editGroup" ? "editGroup" : "editUsers"}
                >
                  {this.state.user.userType === "OEM_ADMIN" ? (
                    <Tab className="tab-shop-profile" eventKey="editGroup" label="Edit Roles">
                      {this.state.roles ? (
                        <div
                          className="flex-row l-gap-1rem overflow-scroll"
                        >
                          <div>
                            <h3 className="col-sm-7 text-center">Group Roles</h3>
                            <div className="auto-auth-table col-sm-7">

                              <CustomTable
                                columns={columnDefs}
                                data={groupRoles}
                                observeResize={false}
                                className="-highlight u-margin-top-large"
                                paginationTop
                                paginationBottom
                                noDataText="No Roles"
                                defaultSort={[
                                  {
                                    id: 'name',
                                    desc: false,
                                  },
                                ]}
                                onCheckmarkChange={this.handleCheckboxChange.bind(this, 'rolesToDelete')}
                              />

                            </div>
                          </div>

                          <div className="l-flex-column parent-center l-flex-gap">
                            <div>
                              <button
                                className="c-btn"
                                onClick={this.handleAddRole.bind(this)}
                                title="Add Role to Group"
                              >
                                <i className="fal fa-arrow-left"></i>
                              </button>
                            </div>
                            <div>
                              <button
                                className="c-btn"
                                onClick={this.handleRemoveRole.bind(this)}
                                title="Remove Role from Group"
                              >
                                <i className="fal fa-arrow-right"></i>
                              </button>
                            </div>
                          </div>

                          <div>
                            <h3 className="col-sm-4 text-center">Roles</h3>
                            <div className="auto-auth-table col-sm-4">

                              <CustomTable
                                columns={roleColDefs}
                                data={filteredRoles}
                                observeResize={false}
                                className="-highlight u-margin-top-large"
                                paginationTop
                                paginationBottom
                                noDataText="No Roles"
                                defaultSort={[
                                  {
                                    id: 'roleName',
                                    desc: false,
                                  },
                                ]}
                                onCheckmarkChange={this.handleCheckboxChange.bind(this, 'rolesToAdd')}
                              />

                            </div>
                          </div>
                        </div>
                      ) : (
                        <Loading />
                      )}
                    </Tab>
                  ) : (
                    ""
                  )}
                  <Tab className="tab-shop-profile" eventKey="editUsers" label="Edit Users">
                    {this.state.users ? (
                      <div
                        className="flex-row l-gap-1rem overflow-scroll"
                      >
                        <div>
                          <h3 className="col-sm-7 text-center">Group Users</h3>
                          <div className="auto-auth-table col-sm-7">

                            <CustomTable
                              columns={groupUsersColDefs}
                              data={groupUsers}
                              observeResize={false}
                              className="-highlight u-margin-top-large"
                              paginationTop
                              paginationBottom
                              noDataText="No Roles"
                              defaultSort={[
                                {
                                  id: 'userID',
                                  desc: false,
                                },
                              ]}
                              onCheckmarkChange={this.handleCheckboxChange.bind(this, 'usersToDelete')}
                            />
                            
                          </div>
                        </div>
                        <div className="l-flex-column parent-center l-flex-gap">
                          <div>
                            <button
                              className="c-btn"
                              onClick={this.handleAddUser.bind(this)}
                              title="Add User to Group"
                            >
                              <i className="fal fa-arrow-left"></i>
                            </button>
                          </div>
                          <div>
                            <button
                              className="c-btn"
                              onClick={this.handleRemoveUser.bind(this)}
                              title="Remove User from Group"
                            >
                              <i className="fal fa-arrow-right"></i>
                            </button>
                          </div>
                        </div>
                        <div>
                          <h3 className="col-sm-4 text-center">Users</h3>
                          <div className="auto-auth-table col-sm-4">
                            
                            <CustomTable
                              columns={userColDefs}
                              data={filteredUsers}
                              observeResize={false}
                              className="-highlight u-margin-top-large"
                              paginationTop
                              paginationBottom
                              noDataText="No Roles"
                              defaultSort={[
                                {
                                  id: 'userID',
                                  desc: false,
                                },
                              ]}
                              onCheckmarkChange={this.handleCheckboxChange.bind(this, 'usersToAdd')}
                            />

                          </div>
                        </div>
                      </div>
                    ) : (
                      <Loading />
                    )}
                  </Tab>
                </Tabs>
              </div>
            </div>
          ) : (
            <Loading />
          )}
        </div>

        <AlertModal
          message={this.state.alertMessage}
          showModal={this.state.showModal}
          handleCancel={this.handleCancel.bind(this)}
        />
        <AlertModal
          message={`${this.state.groupName} has been successfully updated.`}
          showModal={this.state.showUpdatedModal}
          handleCancel={this.handleHideUpdatedModal.bind(this)}
        />
        <ConfirmModal
          showModal={this.state.showConfirmNavModal}
          handleCancel={this.handleNavCancel.bind(this)}
          handleConfirm={this.handleNavConfirm.bind(this, this.state.newPage)}
          title="Unsaved Changes"
          message="You have unsaved changes that will be lost if you navigate away. Do you wish to continue?"
          confirmText="Yes, Ignore Changes"
          cancelText="No, Go Back"
          confirmLoadingText="Continuing..."
        />
      </div>
    );
  }
}
